// Router Dashboard - leader
export default [
  {
    path: 'schedule',
    name: 'schedule',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/schedule/ScheduleMain.vue'),
    meta: {
      roles: ['leader', 'individual'], // sponsor cannot have coach
      navMenuOptions: {
        index: '30',
        label: 'aside.schedule',
        icon: 'el-icon-s-custom',
      },
      // minSession: 1,
    },
  },
  {
    path: 'my-journey',
    name: 'myJourney',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/myJourney/MyJourney.vue'),
    meta: {
      roles: ['sponsor', 'leader', 'individual'],
      navMenuOptions: {
        index: '20-0',
        label: 'aside.myJourney',
        as: 'myJourney',
        icon: 'custom-journey',
      },
    },
  },
  {
    path: 'my-coach',
    name: 'coachSelection',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/coach/CoachMain.vue'),
    meta: {
      roles: ['leader', 'individual'], // sponsor cannot have coach
      navMenuOptions: {
        parent: 'myJourney',
        index: '20-1',
        label: 'aside.coachSelection',
      },
    },
  },
  {
    path: 'lga',
    name: 'lga',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/lga/LGA.vue'),
    meta: {
      roles: ['sponsor', 'leader', 'individual'],
      navMenuOptions: {
        parent: 'myJourney',
        index: '20-10',
        label: 'aside.lga',
      },
      minSession: 1,
    },
  },
  {
    path: 'stakeholders',
    name: 'stakeholders',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/stakeholders/StakeholdersMain.vue'),
    meta: {
      roles: ['sponsor', 'leader', 'individual'],
      // roles: ['hide'],
      navMenuOptions: {
        parent: 'myJourney',
        index: '20-20',
        label: 'aside.stakeholders',
      },
      minSession: 1,
    },
  },
  {
    path: 'alm',
    name: 'alm',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/alm/Alm.vue'),
    meta: {
      // roles: ['sponsor', 'leader', 'individual'],
      roles: ['hide'],
      navMenuOptions: {
        parent: 'myJourney',
        index: '20-30',
        label: 'aside.alm',
      },
      minSession: 1,
    },
  },
  {
    path: 'action-plan',
    name: 'actionPlan',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/actionPlan/ActionPlanMain.vue'),
    meta: {
      roles: ['sponsor', 'leader', 'individual'],
      navMenuOptions: {
        parent: 'myJourney',
        index: '20-55',
        label: 'aside.actionPlan',
      },
      minSession: 4,
    },
  },
  {
    path: 'action-plan/set-up',
    name: 'actionPlanSetUp',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/actionPlan/setup/ActionPlanSetUp.vue'),
    meta: {
      roles: ['leader'],
      minSession: 4,
      navMenuOptions: {
        as: 'actionPlan',
      },
    },
  },
  {
    path: 'action-plan/survey',
    name: 'actionPlanSurvey',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/actionPlan/survey/ActionPlanSurvey.vue'),
    meta: {
      roles: ['leader'],
      minSession: 4,
    },
  },
  {
    path: 'feedforward',
    name: 'feedforward',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/feedforward/Feedforward.vue'),
    meta: {
      roles: ['sponsor', 'leader', 'individual'],
      // roles: ['hide'],
      navMenuOptions: {
        parent: 'myJourney',
        index: '20-60',
        label: 'aside.feedforward',
      },
      minSession: 4,
    },
  },
  {
    path: 'pulse',
    name: 'pulse',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/pulse/PulseMain.vue'),
    meta: {
      roles: ['sponsor', 'leader', 'individual'],
      // roles: ['hide'],
      navMenuOptions: {
        parent: 'myJourney',
        index: '20-70',
        label: 'aside.pulse',
      },
      minSession: 6,
    },
  },
  {
    path: 'lgpr',
    name: 'lgpr',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/lgpr/Lgpr.vue'),
    meta: {
      // roles: ['sponsor', 'leader', 'individual'],
      roles: ['hide'],
      navMenuOptions: {
        index: '70',
        label: 'aside.lgpr',
      },
    },
  },

  {
    path: 'engagements',
    name: 'engagementsList',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/engagements/EngagementsList.vue'),
    meta: {
      roles: ['leader', 'individual'],
      navMenuOptions: {
        index: '40',
        label: 'aside.engagements',
        icon: 'el-icon-s-custom',
      },
    },
  },
  {
    path: 'engagement/:id',
    name: 'engagementDetails',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/engagements/EngagementDetails.vue'),
    meta: {
      roles: ['leader', 'individual'],
      navMenuOptions: {
        as: 'engagementsList',
      },
    },
  },
  {
    path: 'engagement/:id/action-plan',
    name: 'engagementActionPlan',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/engagements/EngagementActionPlan.vue'),
    meta: {
      roles: ['leader', 'individual'],
      navMenuOptions: {
        as: 'engagementsList',
      },
    },
  },
  {
    path: 'engagement/:id/pulse',
    name: 'engagementPulse',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/engagements/EngagementPulse.vue'),
    meta: {
      roles: ['leader', 'individual'],
      navMenuOptions: {
        as: 'engagementsList',
      },
    },
  },
];
